import type { SuccessPayload } from 'components/widgets/invest-component/storage/invest-states'
import { atomsWithMutation } from 'jotai-tanstack-query'
import { parseUnits, erc20Abi } from 'viem'
import { parseApproveTransactionResult } from './utils'
import { wagmiConfig } from 'services/wallet/chains'
import { simulateContract, writeContract } from '@wagmi/core'

export const [approveResponseAtom, approveAtom] = atomsWithMutation(() => ({
  mutationKey: ['approve'],
  mutationFn: async (props: SuccessPayload) => {
    const { sellAmount, inputCurrency, takerAddress, stopProcessing } = props

    const amountInWei = parseUnits(sellAmount.toString(), inputCurrency.decimals)

    if (stopProcessing) stopProcessing()

    const simulation = await simulateContract(wagmiConfig, {
      address: inputCurrency.address,
      abi: erc20Abi,
      functionName: 'approve',
      args: [takerAddress, amountInWei],
    })
    console.log('simulation: ', simulation)

    const hash = await writeContract(wagmiConfig, {
      address: inputCurrency.address,
      abi: erc20Abi,
      functionName: 'approve',
      args: [takerAddress, amountInWei],
    })

    return parseApproveTransactionResult(hash, props)
  },
}))
